import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-[#FAFAF8]">
      {/* Header */}
      <section className="bg-white py-12 border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <Link to="/" className="inline-flex items-center text-[#4CAF50] hover:text-[#43A047] mb-6">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Grįžti į pradžią
          </Link>
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-[#E3F2FD] rounded-2xl flex items-center justify-center">
              <FileText className="w-8 h-8 text-[#5B9BD5]" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748]">
                Naudojimo sąlygos
              </h1>
              <p className="text-[#718096]">Paskutinis atnaujinimas: 2025 m. sausio mėn.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="bg-white rounded-3xl p-8 md:p-12 border border-slate-100 prose prose-slate max-w-none">
            
            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748] mt-0">1. Bendrosios nuostatos</h2>
            <p className="text-[#718096] leading-relaxed">
              Šios naudojimo sąlygos (toliau – „Sąlygos") reglamentuoja svetainės tavoemocijos.lt 
              (toliau – „Svetainė") ir joje siūlomų paslaugų naudojimą.
            </p>
            <p className="text-[#718096] leading-relaxed">
              Naudodamiesi Svetaine, jūs sutinkate su šiomis Sąlygomis. Jei nesutinkate, 
              prašome nesinaudoti Svetaine.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">2. Paslaugų aprašymas</h2>
            <p className="text-[#718096] leading-relaxed">Svetainė siūlo:</p>
            <ul className="text-[#718096] space-y-2">
              <li>Informaciją apie mokymų ir koučingo paslaugas</li>
              <li>Skaitmeninius produktus (PDF vadovus, video kursus, audio meditacijas)</li>
              <li>Galimybę susisiekti ir užsisakyti paslaugas</li>
              <li>Naujienlaiškio prenumeratą</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">3. Vartotojo įsipareigojimai</h2>
            <p className="text-[#718096] leading-relaxed">Naudodamiesi Svetaine, įsipareigojate:</p>
            <ul className="text-[#718096] space-y-2">
              <li>Pateikti teisingą ir tikslią informaciją</li>
              <li>Nenaudoti Svetainės neteisėtais tikslais</li>
              <li>Neplatinti įsigyto turinio be leidimo</li>
              <li>Gerbti autorines teises</li>
              <li>Nenaudoti automatinių sistemų duomenų rinkimui</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">4. Intelektinė nuosavybė</h2>
            <p className="text-[#718096] leading-relaxed">
              Visas Svetainės turinys (tekstai, vaizdai, logotipai, video, audio, dizainas) 
              yra saugomas autorių teisių ir priklauso TavoEmocijos arba turinio autoriams.
            </p>
            <p className="text-[#718096] leading-relaxed">
              Draudžiama kopijuoti, platinti, modifikuoti ar viešai rodyti Svetainės turinį 
              be raštiško sutikimo.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">5. Skaitmeniniai produktai</h2>
            <p className="text-[#718096] leading-relaxed">
              Įsigydami skaitmeninius produktus, gaunate asmeninę licenciją naudoti:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li>Produktas skirtas tik asmeniniam naudojimui</li>
              <li>Draudžiama dalintis, perparduoti ar viešai platinti</li>
              <li>Galite atsispausdinti PDF failus asmeniniam naudojimui</li>
              <li>Produktai pristatomi elektroniniu būdu</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">6. Kainos ir mokėjimai</h2>
            <ul className="text-[#718096] space-y-2">
              <li>Visos kainos nurodytos eurais (EUR) su PVM</li>
              <li>Mokėjimai apdorojami per Paysera mokėjimo sistemą</li>
              <li>Užsakymas patvirtinamas gavus mokėjimą</li>
              <li>Skaitmeniniai produktai pristatomi automatiškai po mokėjimo</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">7. Mokymų ir konsultacijų paslaugos</h2>
            <p className="text-[#718096] leading-relaxed">
              Mokymų ir koučingo sesijų sąlygos aptariamos individualiai. Bendros nuostatos:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li>Tikslios sąlygos ir kainos derinamos prieš paslaugų teikimą</li>
              <li>Atšaukimo sąlygos nurodomos sutartyje</li>
              <li>Konfidencialumas užtikrinamas pagal profesinę etiką</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">8. Atsakomybės ribojimas</h2>
            <p className="text-[#718096] leading-relaxed">
              Svetainėje pateikiama informacija yra bendro pobūdžio ir negali pakeisti 
              profesionalios medicininės ar psichologinės pagalbos.
            </p>
            <p className="text-[#718096] leading-relaxed">
              Neprisiimame atsakomybės už:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li>Svetainės veikimo sutrikimus</li>
              <li>Nuostolius dėl informacijos netikslumų</li>
              <li>Trečiųjų šalių svetainių turinį</li>
              <li>Neteisėtą turinio naudojimą</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">9. Privatumas</h2>
            <p className="text-[#718096] leading-relaxed">
              Jūsų duomenys tvarkomi pagal mūsų{' '}
              <Link to="/privatumas" className="text-[#4CAF50] hover:underline">Privatumo politiką</Link>.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">10. Sąlygų keitimas</h2>
            <p className="text-[#718096] leading-relaxed">
              Pasiliekame teisę keisti šias Sąlygas. Pakeitimai įsigalioja nuo paskelbimo 
              Svetainėje. Esminių pakeitimų atveju informuosime el. paštu.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">11. Ginčų sprendimas</h2>
            <p className="text-[#718096] leading-relaxed">
              Šioms Sąlygoms taikoma Lietuvos Respublikos teisė. Ginčai sprendžiami derybų 
              būdu, o nepavykus – Lietuvos Respublikos teismuose.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">12. Kontaktai</h2>
            <p className="text-[#718096] leading-relaxed">
              Klausimai dėl naudojimo sąlygų:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>El. paštas:</strong> info@tavoemocijos.lt</li>
              <li><strong>Adresas:</strong> Vilnius, Lietuva</li>
            </ul>

          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
